<script setup lang="tsx">
import { ref } from "vue";

const props = withDefaults(
  defineProps<{
    bgColor?: string;
    progressColor?: string;
    borderColor?: string;
    borderRadius?: string;
    showText?: boolean;
  }>(),
  {
    bgColor: "#efefef",
    progressColor: "#a0dde9",
    borderColor: "#eeeeee",
    borderRadius: "4px",
    showText: false
  }
);

const emits = defineEmits<{
  (event: "complete", currentPercent: number): void;
}>();

const barPercent = ref(0);

function goto(toValue: number) {
  barPercent.value = Math.min(Math.max(0, toValue), 100);
  emits("complete", barPercent.value);
}

defineExpose({ goto });
</script>

<template>
  <div
    class="bar"
    :style="{
      border: `1px solid ${props.borderColor}`,
      borderRadius: props.borderRadius,
      backgroundColor: props.bgColor
    }"
  >
    <div
      class="bar-inner"
      :style="{ width: barPercent + '%', backgroundColor: props.progressColor }"
    >
      {{ props.showText ? barPercent + "%" : "" }}
    </div>
  </div>
</template>

<style scoped>
.bar {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.bar-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 100%;
  text-align: center;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666666;
}
</style>
